import { createSlice , createAsyncThunk } from "@reduxjs/toolkit";
import { reject } from "lodash";
import { error } from "src/theme/palette";
import bearerToken from "../constant/token"
//Create roles by createAsyncThunk
export const CreateRoles = createAsyncThunk("create/roles" , async(data , {rejectWithValue})=>{
    console.log("create/roles" , data)
    const FetchedDataWithApi = await fetch("http://localhost:4500/v1/roles",{
        method : "POST",
        headers:{
            'Authorization': `Bearer ${bearerToken}`,
            'content-type':"application/json"
        },
        body : JSON.stringify(data)
    })
    try{
        const resultData = await FetchedDataWithApi.json()
        console.log("post ResultData" , resultData)
        return resultData
    }catch(error){
        return rejectWithValue("something wrong",error)
    }
});

//Read roles by createAsyncThunk
export const ReadRoles = createAsyncThunk("read/roles" , async(data , {rejectWithValue})=>{
    //fetching data with api 1st we have to take console
    console.log("read/roles" , data)
    const FetchedDataWithApi = await fetch("http://localhost:4500/v1/roles",{
        method:"GET",
        headers:{
            'Authorization': `Bearer ${bearerToken}`
        }
    })
    try{
        const resultData = await FetchedDataWithApi.json()
        console.log("this will be the read data" , resultData)
        return resultData;
    }catch(error){
        return rejectWithValue("something wrong" , error)
    }
})

//Update roles by createAsyncThunk
export const UpdateRoles = createAsyncThunk("updates/roles" , async(data , {rejectWithValue})=>{
    //fetching data with api 1st we have to take it console
    console.log("updates/roles" , data)
    const FetchedDataWithApi = await fetch(`http://localhost:4500/v1/roles/${data.id}`,{
        method:"PATCH",
        headers:{
            'Authorization': `Bearer ${bearerToken}`,
            'content-type':"application/json"
        },
        body:JSON.stringify(data)
    })
    try{
        const resultData = await FetchedDataWithApi.json()
        console.log("this will be the update data" , resultData)
        return resultData
    }catch(error){
        return rejectWithValue("something wrong" , error)
    }
})

//delete roles with createAsyncThunk
export const DeleteRoles = createAsyncThunk("delete/roles" , async(id , {rejectWithValue})=>{
    //fetching data with api 1st we have to take it console
    console.log("delete/roles" , id)
    const FetchedDataWithApi = await fetch(`http://localhost:4500/v1/roles/${id}`,{
        method:"DELETE",
        headers:{
            'Authorization': `Bearer ${bearerToken}`,
            "content-type":'application/json'
        },
        body: JSON.stringify(id)
    })
    try{
        const resultData = await FetchedDataWithApi.json()
        console.log("this will be the Delete data" , resultData)
        return resultData
    }catch(error){
        return rejectWithValue("something wrong" , error)
    }
});

//slices creation for role Data
export const roleDetail = createSlice({
    name: "role",
    initialState: {
      role: [],
      loading: false,
      error: null,
      searchData: [],
      deleteSuccess: false,
      registerSuccess : false
    },
    reducers: {
      searchRoles: (state, action) => {
        console.log(action.payload);
        state.searchData = action.payload;
      },
      resetRegisterSuccess: (state) => {
        state.registerSuccess = false;
    },
    resetDeleteSucess: (state) => {
      state.deleteSuccess = false;
  }
    },
    extraReducers: (builder) => {
      builder
        .addCase(CreateRoles.pending, (state) => {
          state.loading = true;
          state.registerSuccess = false;
        })
        .addCase(CreateRoles.fulfilled, (state, action) => {
          state.loading = false;
          state.role.push(action.payload);
          state.registerSuccess = true;
        })
        .addCase(CreateRoles.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload.message;
          console.log("this will be the error massage" , error)
          state.registerSuccess = false
        })
        .addCase(ReadRoles.pending, (state) => {
          state.loading = true;   
        })
        .addCase(ReadRoles.fulfilled, (state, action) => {
          state.loading = false;
          state.role = action.payload;
        })
        .addCase(ReadRoles.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        })
        .addCase(DeleteRoles.pending, (state) => {
          state.loading = true;
          state.deleteSuccess = false;
        })
        .addCase(DeleteRoles.fulfilled, (state, action) => {
          state.loading = false;
          const { id } = action.payload;
          if (id) {
            state.role = state.role.filter((ele) => ele.id !== id);
            state.deleteSuccess = true;
          }
        })
        .addCase(DeleteRoles.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
          state.deleteSuccess = false
        })
        .addCase(UpdateRoles.pending, (state) => {
          state.loading = true;
        })
        .addCase(UpdateRoles.fulfilled, (state, action) => {
          state.loading = false;
          state.role = state.role.map((ele) =>
            ele.id === action.payload.id ? action.payload : ele
          );
        })
        .addCase(UpdateRoles.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload.message;
        });
    },
  });
  
  export default roleDetail.reducer;
  export const { searchRoles , resetRegisterSuccess , resetDeleteSucess} = roleDetail.actions;